function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.878 13a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5Zm0 2.5a5.75 5.75 0 1 0 0-11.5 5.75 5.75 0 0 0 0 11.5ZM9.807 11.42a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm2.5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM3.372 24.5h3.944V27H1.872a1 1 0 0 1-1-1v-4.73c0-.711.385-1.366 1.006-1.712a20.547 20.547 0 0 1 5.438-2.081v2.573c-1.356.353-2.68.867-3.944 1.541V24.5Zm8.256 1h16.5v-2.924a17.307 17.307 0 0 0-16.5 0V25.5Zm-2.5-3.285c0-.678.364-1.304.954-1.64a19.806 19.806 0 0 1 19.593 0c.59.336.953.962.953 1.64V27a1 1 0 0 1-1 1h-19.5a1 1 0 0 1-1-1v-4.785Z"
  }));
};
var componentName = 'GroupOutlined';
export var GroupOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
GroupOutlined.displayName = componentName;